import React from "react"
import { Icon, Select } from "antd";
import Country from 'country-data';
import { CheckCircleFilled, ClockCircleFilled } from '@ant-design/icons';
import { AGREEMENT_COMPLETE, AGREEMENT_INCOMPLETE, AGREEMENT_SUBMIT, BUSINESS_COMPLETE, BUSINESS_INCOMPLETE, BUSINESS_SUBMIT, OPERATOR_COMPLETE, OPERATOR_INCOMPLETE, OPERATOR_SUBMIT } from "../../config/media";

export const statusInfo = {
    0: { state: 'Incomplete', className: 'red-text', image: { operator: OPERATOR_INCOMPLETE, business: BUSINESS_INCOMPLETE, agreement: AGREEMENT_INCOMPLETE } },
    1: { state: 'Incomplete', className: 'red-text', image: { operator: OPERATOR_INCOMPLETE, business: BUSINESS_INCOMPLETE, agreement: AGREEMENT_INCOMPLETE } },
    3: { state: 'Complete', className: 'green-text', image: { operator: OPERATOR_COMPLETE, business: BUSINESS_COMPLETE, agreement: AGREEMENT_COMPLETE } },
    4: { state: 'submitted for processing', className: 'orange-text', image: { operator: OPERATOR_SUBMIT, business: BUSINESS_SUBMIT, agreement: AGREEMENT_SUBMIT } },
}

export const statusIncomplete = (statusState = 0) => {
    return (
        <div className="status-incomplete-field">
            {statusState.state === 'submitted for processing' && <ClockCircleFilled style={{ color: '#FFA500' }} />}
            {statusState.state === 'Complete' && <CheckCircleFilled style={{ color: '#009B29' }} />}
            <div className="bold">Status:</div>
            <div>{statusState.state === 'submitted for processing' ? 'submitted for processing' : statusState.state}</div>
        </div>
    )
}

export const ExclamationCircle = () => {
    return (
        <Icon
            type="exclamation-circle"
            theme="filled"
            style={{ fontSize: '13px', color: '#fff' }}
            className="exclamation-icon"
        />
    )
}

export const renderCountries = () => {
    const country = Country.countries.all
        .filter((item) => {
            return item.status === 'assigned';
        })
        .sort((a, b) => {
            const nameA = a.name.toUpperCase(),
                nameB = b.name.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    return country.map((item) => {
        return (
            <Select.Option key={item.alpha2}>
                <span className={`flag-icon flag-icon-${item.alpha2.toLowerCase()} icon`} /> {item.name}
            </Select.Option>
        );
    });
};

export const getFields = (form, name, message, initialValue) => {

    const { getFieldDecorator } = form

    return getFieldDecorator(name, {
        initialValue, rules: [
            {
                required: true,
                message
            },
        ],
    })

}

export const checkInitialStatus = (userInfo) => {
    if (userInfo) return 3
    else return 0
}